import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { ValidationResultModel } from '../../shared/models/validation-results/validation-result.model';
import { ValidationStateModel } from '../../shared/models/validation-results/validation-state.model';
import { ValidationModel } from '../../shared/models/validation-results/validation.model';

@Injectable()
export class UserService extends BaseApiService {
    public getUsersBySecurityTransactionType = (securityTransactionTypeId: number): Observable<any> => this.get(`Foundation/User/SecurityTransactionType/${securityTransactionTypeId}`);

    public getCustomerUserAgentCustomerNumbers(): Observable<number[]> {
        return this.get('Foundation/User/CustomerUserAgentCustomerNumbers').pipe(map(r => r.result));
    }

    public createAccessToUserDeniedValidationError() {
        const validationModel: ValidationModel = new ValidationModel([]);
        const val: ValidationResultModel = new ValidationResultModel();
        const state: ValidationStateModel = new ValidationStateModel();
        state.validationType = 'Error';
        val.errorMessage = 'Access to user is denied.';
        val.source = 'Model';
        val.state = state;
        validationModel.validationResults.push(val);
        return validationModel;
    }
}
